import moment from 'moment';
import React from 'react';
import { withRouter } from 'react-router-dom';

import LoanService from '../../../Service/LoanService';
import Table from '../../Common/Table';
import { convertToPhilippinesTime } from '../../../AppUtil/AppUtil';

class TransfersDueInstallments extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			_showModal: false,
			_transferdueinstallmentsid: null
		};
	}

	setTranferDueIntallmentsSource = async queryUrl => {
		return LoanService.getDisbursalInstallments(this.props.match.params.id, queryUrl);
	};

	handleShowModal = id => {
		this.setState({
			_showModal: !this.state._showModal,
			_transferdueinstallmentsid: id
		});
	};

	render() {
		const tdi = [
			{
				name: 'installment_date',
				label: 'Date/Time',
				options: {
					sort: false,
					customBodyRender: value => {
						return (
							<span className="bold-important">{value ? convertToPhilippinesTime(value) : 'N/A'}</span>
						);
					}
				}
			},
			{
				name: 'loan_type',
				label: 'loan type',

				options: {
					display: 'excluded'
				}
			},

			{
				name: 'loan_id',
				label: 'Loan ID',
				options: {
					sort: true,
					customBodyRender: (value, tableMeta) => {
						if (tableMeta.rowData[1] === 'LEND') {
							return (
								<a
									href={`/admin/customer/loan/loan-details/${value}?creator_name=${
										tableMeta.rowData[5]
									}&acceptor_name=${tableMeta.rowData[4]}&mode_payment=${
										tableMeta.rowData[11] || tableMeta.rowData[12]
									}&type=installment`}
									target="_blank">
									<span className="bold-important">{`LA${String(value).padStart(5, '0')}`}</span>
								</a>
							);
						} else {
							return (
								<a
									href={`/admin/customer/loan/loan-details/${value}?creator_name=${
										tableMeta.rowData[4]
									}&acceptor_name=${tableMeta.rowData[5]}&mode_payment=${
										tableMeta.rowData[11] || tableMeta.rowData[12]
									}&type=installment`}
									target="_blank">
									<span className="bold-important">{`LA${String(value).padStart(5, '0')}`}</span>
								</a>
							);
						}
					}
				}
			},

			{
				name: 'filtertab',
				label: 'Loan Type',
				options: {
					sort: false,
					customBodyRender: value => {
						value = 'Installment';
						return value;
					}
				}
			},

			{
				name: 'creator_name',
				label: 'From',
				options: {
					sort: false,
					customBodyRender: (value, tableMeta) => {
						if (tableMeta.rowData[1] === 'LEND') {
							return tableMeta.rowData[5];
						}
						return value || '--';
					}
				}
			},

			{
				name: 'acceptor_name',
				label: 'To',
				options: {
					sort: false,
					customBodyRender: (value, tableMeta) => {
						if (tableMeta.rowData[1] === 'LEND') {
							return tableMeta.rowData[4];
						}
						return value || '--';
					}
				}
			},

			{
				name: 'channel',
				label: 'Channel',
				options: {
					sort: false,
					customBodyRender: (_value, tableMeta) => {
						return 'LendAmi Wallet';
					}
				}
			},

			{
				name: 'emi_amount',
				label: 'Amount(₱) + (lendAmi fee)',
				options: {
					sort: false,
					customBodyRender: (value, tableMeta) => {
						const PHP = new Intl.NumberFormat('PH', {
							style: 'currency',
							currency: 'PHP'
						});

						return (
							<span className="bold-important">
								{PHP.format(parseFloat(value) + parseInt(tableMeta.rowData[8]))}
							</span>
						);
					}
				}
			},

			{
				name: 'transaction_fee',
				label: 'Transaction Fee',
				options: {
					display: 'excluded',
					customBodyRender: value => {
						return <span className="bold-important">{value}</span>;
					}
				}
			},

			{
				name: 'loan_id',
				label: 'Amortization Table',
				options: {
					sort: false,
					customBodyRender: (value, tableMeta) => (
						<a
							href={`/amortization-table/${value}?id=${this.props.match.params.id}&notification=true&type=installments-history&installment_id=${tableMeta.rowData[13]}`}
							style={{ color: 'red', fontWeight: 'bold' }}>
							Transaction
						</a>
					)
				}
			},

			{
				name: 'loan_id',
				label: 'Action',
				options: {
					sort: false,
					customBodyRender: (value, tableMeta) => {
						if (tableMeta.rowData[1] === 'LEND') {
							return (
								<a
									href={`/admin/customer/loan/loan-details/${value}?creator_name=${
										tableMeta.rowData[5]
									}&acceptor_name=${tableMeta.rowData[4]}&mode_payment=${
										tableMeta.rowData[11] || tableMeta.rowData[12]
									}&type=installment`}
									target="_blank">
									Detail
								</a>
							);
						} else {
							return (
								<a
									href={`/admin/customer/loan/loan-details/${value}?creator_name=${
										tableMeta.rowData[4]
									}&acceptor_name=${tableMeta.rowData[5]}&mode_payment=${
										tableMeta.rowData[11] || tableMeta.rowData[12]
									}&type=installment`}
									target="_blank">
									Detail
								</a>
							);
						}
					}
				}
			},
			{
				name: 'disbursal_mode',
				label: 'Disbursal Mode',

				options: {
					display: 'excluded'
				}
			},
			{
				name: 'latest_disbursal_mode',
				label: 'Latest Disbursal Mode',

				options: {
					display: 'excluded'
				}
			},
			{
				name: 'id',
				label: 'Loan ID',

				options: {
					display: 'excluded'
				}
			}
		];

		return (
			<>
				<Table
					columns={tdi}
					dataSourceHandler={this.setTranferDueIntallmentsSource}
					dataSourceName="installment"
					title="Installment Transactions"
				/>
			</>
		);
	}
}

export default withRouter(TransfersDueInstallments);
